import { throwError } from "@/lib/throwError";
import { del, get, post, put } from "@/services/axiosUitils";
import {
  getSocialConfigurationById,
  SocialConfiguration,
  SocialConfigurationPayload,
  SocialConfigurationResponse,
} from "@/utils/types/socialConfiguration";

const base = "/social-login-config/";

class SocialConfigurationService {
  listSocialConfigurations = async (
    page = 1,
    page_size = 20
  ): Promise<SocialConfigurationResponse<SocialConfiguration>> => {
    return await get<SocialConfigurationResponse<SocialConfiguration>>(base, {
      params: { page, page_size },
    });
  };

  getSocialConfigurationById = async (
    id: string
  ): Promise<getSocialConfigurationById> => {
    if (!id) {
      throwError("ID is required", "SocialConfigurationService");
    }
    return await get<getSocialConfigurationById>(`${base}${id}/`);
  };

  createSocialConfiguration = async (
    user: SocialConfigurationPayload
  ): Promise<SocialConfiguration> => {
    return await post<SocialConfiguration>(base, user);
  };

  updateSocialConfiguration = async (
    id: string,
    user: SocialConfigurationPayload
  ): Promise<SocialConfiguration> => {
    return await put<SocialConfiguration>(`${base}${id}/`, user);
  };

  deleteSocialConfiguration = async (id: string): Promise<void> => {
    return await del<void>(`${base}${id}/`);
  };
}

const instance = new SocialConfigurationService();
export default instance;
